import { IconArrowProfile } from '@app/icons';
import { memo } from 'react';
import { Card, CardContent } from 'components/ui/card';
import { Button } from 'components/ui/button';

const Pagination = memo(() => {
  return (
    <Card className="w-full p-4 flex flex-col md:flex-row items-center justify-between gap-4">
      <CardContent className="flex flex-col md:flex-row items-center gap-4 w-full p-0">
        <div className="flex items-center gap-2">
          <span className="text-sm text-muted-foreground">Кол-во строк:</span>
          <div className="flex items-center gap-1 border rounded px-2 py-1">
            100
            <IconArrowProfile />
          </div>
        </div>
        <div className="flex items-center gap-2 ml-auto">
          <span className="text-sm text-muted-foreground">Страница: 1/0</span>
          <div className="flex items-center gap-1">
            <Button size="icon" variant="ghost" className="p-1">
              <IconArrowProfile />
            </Button>
            <Button size="icon" variant="ghost" className="p-1">
              <IconArrowProfile />
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
});
export default Pagination;
